import { render, staticRenderFns } from "./SelectPersonModal.vue?vue&type=template&id=174f28fe"
import script from "./SelectPersonModal.vue?vue&type=script&lang=js"
export * from "./SelectPersonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports